
export default {
  v3SubmitErrBtnViewOrder: '查看訂單',
  v3SubmitErrBtnBackHome: '返回首頁',
  v3SubmitErrBtnRetry: '重試',
  v3SubmitErrBtnRelogin: '重新登入',
  v3SubmitErrBtnSwitchPay: '切換支付方式',
  v3SubmitErrBtnReorder: '重新下單',
  v3SubmitErrBtnSwitchServer: '切換區服',
  v3SubmitErrBtnViewOrderStatus: '查看訂單狀態',
  v3SubmitErrBtnBackStore: '返回商城',
  v3SubmitErrBtnGoUpdate: '去更新',
  v3SubmitErrBtnResubscribe: '重新訂閱',
  v3SubmitErrTipUpdateApp: '請前往應用商店更新',
  v3SubmitErrTipRelogin: '請重新登入',

  v3SubmitErrMsg120009: '訂單已處理，請前往遊戲內查看背包。',
  v3SubmitErrMsg120003: '商品資訊有誤，請重新選擇商品。',
  v3SubmitErrMsg120016: '提交過於頻繁，請稍等幾秒再試。',
  v3SubmitErrMsg120025: '請求參數異常，請重新登入後重試。',
  v3SubmitErrMsg121012: '支付渠道暫時不可用，請嘗試其他方式。',
  v3SubmitErrMsg120012: '網路不穩定，請檢查網路連線後重試。',
  v3SubmitErrMsg120002: '未檢測到遊戲角色，請先建立角色。',
  v3SubmitErrMsg121019: '訂單資訊錯誤，請重新下單。',
  v3SubmitErrMsg120024: '預註冊禮包已領取，無需重複操作。',
  v3SubmitErrMsg120000: '登入已過期，請重新登入。',
  v3SubmitErrMsg120014: '訂單號無效，請重新下單。',
  v3SubmitErrMsg121001: '儲值到遊戲失敗，請稍後重試或聯繫客服。',
  v3SubmitErrMsg120015: '支付金額異常，請重新選擇商品。',
  v3SubmitErrMsg120001: '遊戲區服不匹配，請切換至正確區服。',
  v3SubmitErrMsg120020: '支付渠道返回異常，請嘗試其他方式。',
  v3SubmitErrMsg120010: '遊戲儲值功能暫時關閉，請稍後再試。',
  v3SubmitErrMsg120006: '金額驗證失敗，請重新選擇。',
  v3SubmitErrMsg121010: '沙盒環境儲值請求無效，請使用正式版。',
  v3SubmitErrMsg120017: '訂單號重複，請檢查是否已支付。',
  v3SubmitErrMsg120022: '支付回調驗證失敗，請稍後重試。',
  v3SubmitErrMsg121000: '系統繁忙，請稍後重試。',
  v3SubmitErrMsg120011: '商品ID錯誤，請重新選擇。',
  v3SubmitErrMsg121015: '支付金額校驗失敗，請重新下單。',
  v3SubmitErrMsg120004: '當前支付渠道未開放，請選擇其他方式。',
  v3SubmitErrMsg120005: '支付渠道維護中，請使用其他方式。',
  v3SubmitErrMsg120007: '平台ID有誤，請重新登入。',
  v3SubmitErrMsg120008: '請求參數不足，請重新提交。',
  v3SubmitErrMsg120013: '開發商訂單號錯誤，請重新下單。',
  v3SubmitErrMsg120018: '支付被風控攔截，請聯繫客服核實。',
  v3SubmitErrMsg120019: '包名驗證失敗，請使用官方版本。',
  v3SubmitErrMsg120021: '商品ID驗證失敗，請重新選擇。',
  v3SubmitErrMsg120023: '預註冊禮包發獎異常，請稍後查看。',
  v3SubmitErrMsg120026: '帳號不存在，請檢查帳號狀態。',
  v3SubmitErrMsg120030: '商品總庫存不足，請選擇其他商品。',
  v3SubmitErrMsg120031: '您已超出該商品限購數量，請調整。',
  v3SubmitErrMsg120032: '遊戲版本過舊，請下載最新版本。',
  v3SubmitErrMsg120080: '風控代理支付限制，請使用自有支付方式。',
  v3SubmitErrMsg120081: '風控代理支付延遲，請稍後查看結果。',
  v3SubmitErrMsg121002: '訂單快取失效，請重新下單。',
  v3SubmitErrMsg121003: '儲值配置不存在，請聯繫客服。',
  v3SubmitErrMsg121004: '擴展參數不足，請重新提交。',
  v3SubmitErrMsg121005: '快取寫入失敗，請稍後重試。',
  v3SubmitErrMsg121006: '快取讀取失敗，請稍後重試。',
  v3SubmitErrMsg121007: '儲值類型配置錯誤，請聯繫客服。',
  v3SubmitErrMsg121011: '蘋果渠道檢測到新欄位，請更新應用。',
  v3SubmitErrMsg121013: '續訂訂單不存在，請重新訂閱。',
  v3SubmitErrMsg121014: '儲值參數解密失敗，請重新提交。',
  v3SubmitErrMsg121017: '此訂單已退款，請聯繫客服確認。',
  v3SubmitErrMsg121018: '訂閱已過期，請重新訂閱。',
  v3SubmitErrMsg121020: '訂單已取消，請重新下單。',
  v3SubmitErrMsg121021: 'Google API 異常，請稍後重試。',
  v3SubmitErrMsg121022: '取得存取權杖失敗，請重新登入。',
  v3SubmitErrMsg121023: '訂單狀態異常，請查詢到帳狀態。',
  v3SubmitErrMsg121024: '訂單確認失敗，請稍後重試。'
};
